/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import type {BucketPane} from './index';
import {BasicBucketPaneEl} from './basic-bucket-pane/panel';
import {SegmentBucketPaneEl} from './segment-bucket-pane/panel';

export function template(this: BucketPane) {
  const isSegmentBucket = Boolean(this.state.segment);
  return isSegmentBucket ? (
    <SegmentBucketPaneEl
      eventNames={this.attr(`event-names`)}
      header={this.attr(`header`)}
      maxNumBuckets={this.attr(`max-num-buckets`)}
      onClose={this.close.bind(this)}
      onUpdateSegment={(updatedSegment) =>
        this.dispatchEvent(new CustomEvent(`updateSegment`, {detail: {segment: updatedSegment}}))
      }
      rangeMin={this.attr(`range-min`)}
      resetBucket={this.attr(`reset-bucket`)}
      segment={this.state.segment}
      selectedBucket={this.attr(`selected-bucket`)}
      selectedUnit={this.attr(`selected-unit`)}
      units={this.attr(`units`)}
      unitsAsProperty={this.attr(`units-as-property`)}
    />
  ) : (
    <BasicBucketPaneEl
      header={this.attr(`header`)}
      maxNumBuckets={this.attr(`max-num-buckets`)}
      onChangeSelectedBucket={(updatedBucket) =>
        this.dispatchEvent(new CustomEvent(`changeSelectedBucket`, {detail: updatedBucket}))
      }
      onResetBucket={this.resetInterval.bind(this)}
      rangeMin={this.attr(`range-min`)}
      resetBucket={this.attr(`reset-bucket`)}
      selectedBucket={this.state.editedBucket || this.attr(`selected-bucket`)}
      selectedUnit={this.attr(`selected-unit`)}
      units={this.attr(`units`)}
    />
  );
}
